import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavItem } from '@retailer-platform/dashboard/routing'
import { clientEnv } from '@retailer-platform/dashboard/env'
import { widgetsRouter } from './routing/widgetsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { widgetsConfigViewAccessControl } from './access-control/widgetsAccess.configuration'
import EN_US from './translations/en-US'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const isProduction = clientEnv.PUBLIC_CLIENT_ENVIRONMENT === 'production'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'widgets',
  totem: {
    entity: 'widgets-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    scoped: [widgetsRouter],
  },
  navigationEntries: isProduction
    ? []
    : [
        {
          attachTo: NavItem.Storefront,
          attachToV2: NavEntryPoint.Merchandising,
          subNavItems: [
            {
              type: 'item',
              route: 'widgets-config',
              accessControl: widgetsConfigViewAccessControl,
              labelId: 'widgetsDomain.common.title',
              position: 11,
              positionNavV2: 8,
            },
          ],
        },
      ],
}

export default definition
